import { render, staticRenderFns } from "./CarbonTransfer2.vue?vue&type=template&id=512c4d70&scoped=true&"
import script from "./CarbonTransfer2.vue?vue&type=script&lang=js&"
export * from "./CarbonTransfer2.vue?vue&type=script&lang=js&"
import style0 from "./CarbonTransfer2.vue?vue&type=style&index=0&id=512c4d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c4d70",
  null
  
)

export default component.exports